
// Import Hero section component
import Hero from "../components/Hero";
// Import image assets
import HeroImage from "../../assets/images/Blogs1.png";
import logo from "../../assets/images/Logo-light 1.png";
import service1 from "../../assets/images//Homepage 2.png";
import service2 from "../../assets/images/Homepage 3.png";
import service3 from "../../assets/images/Homepage 4.png";
import servicesBackground from "../../assets/images/BG_HomePage.jpg";
import Blog1 from "../../assets/images/Blog2.png";
// Import navigation and button components
import { useNavigate } from "react-router-dom";
import Button from "../components/Button";
// Import CSS for landing page styling
import "../../css/LandingPage.css";


/**
 * BlogsPage component for displaying blog articles and a hero section.
 *
 * Sections:
 * - Hero section: Title, background image, and call-to-action button
 * - Blog cards: List of blog articles with image, summary, date, and link
 */
const BlogsPage = () => {
  const navigate = useNavigate();
  // List of blog articles
  const blogs = [
    {
      title: "What’s happening with inflation, and why is it important?",
      image: Blog1,
      summary:
        "After inflation reached a whopping 11.1% in October 2022, we have been seeing a slow but steady decline resulting in it falling to 3% this January (inching ever closer to the Bank of England’s 2% target). But what does all of this mean for you?",
      date: "02/03/2026",
      link: "https://www.linkedin.com/pulse/whats-happening-inflation-why-important-oakmont-financial-services-cwnce/",
    },
  ];
  return (
    <div className="landing-page">
      {/* Hero section with title and background image */}
      <Hero
        title={"Blogs"}
        backgroundImage={HeroImage}
        titleAlign="center"
        subtitleAlign="center"
        buttonText="BOOK A CONSULTATION"
        onButtonClick={() => {
          navigate("/contact");
        }}
        // logo={logo}
      />
      {/* Blog articles section with background image */}
      <section
        className="services-section"
        style={{
          backgroundImage: `url(${servicesBackground})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        {/* Blog cards row */}
        <div className="service-row">
          <div className="service-cards" style={{ justifyContent: "center" }}>
            {blogs.map((blog, index) => (
              <div key={index} className="service-card">
                {/* Blog image */}
                <img src={blog.image} alt={blog.title} />
                {/* Blog title */}
                <div className="subtitle-semibold">{blog.title}</div>
                {/* Blog summary */}
                <div className="card-content">
                  <div className="content-large">{blog.summary}</div>
                </div>
                {/* Blog date */}
                <div className="content-small-italic">{blog.date}</div>
                {/* Read More button opens blog link in new tab */}
                <Button
                  text="Read More"
                  variant="card"
                  onClick={() => {
                    window.open(blog.link, "_blank");
                  }}
                />
              </div>
            ))}
          </div>
        </div>
        {/*
          Example service card for future expansion:
          <div className="service-card">
            <img src={service1} alt="Commercial Financial advice" />
            <div className="subtitle-semibold">Mortgages</div>
            <div className="card-content">
              <div className="content-large">
                Whether you are a first-time buyer, looking to remortgage, or
                want to build on your buy to let portfolio. At Oakmont we can
                help you.
              </div>
              <div className="content-small-italic">
                Your home may be repossessed if you do not keep up repayments
                on your mortgage.
              </div>
            </div>
            <Button
              text="Find Out More"
              variant="card"
              onClick={() => {
                navigate("/services#mortgages");
              }}
            />
          </div>
        */}
      </section>
    </div>
  );
};


// Export the BlogsPage component as default
export default BlogsPage;
